<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    //每30分钟检查一次
    setInterval(() => {
      if(localStorage.getItem('closeTime')){
        if(new Date().getTime() > localStorage.getItem('closeTime')){
          this.$store.dispatch('user/logout')
        }
      }
    },1800000)
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: 'ALIMAMASHUHEITI';
  src: url('/static/font/ALIMAMASHUHEITI-BOLD.TTF') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
</style>



// WEBPACK FOOTER //
// src/App.vue